import React from 'react';
import { history } from 'containers/App';

import ErrorPage from 'components/Errors/ErrorPage';

const NotFoundError = () => <ErrorPage title="Not Found" type="notfound" showButton onButtonClick={ () => history.go(-1) }>
  <p>The requested resource does not exist.</p>
  <p className="cp-primary"><b>404</b></p>
  <p>Please reload and try again.</p>
  <p>If the problem persists please contact our helpdesk.</p>
</ErrorPage>;

export default NotFoundError;
